import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

const SchemasHelmet = ({
  vehicleSchema,
  productSchema,
  carSchema,
  webPageSchema
}) =>
  <Helmet>
    <script type="application/ld+json">
      {vehicleSchema}
    </script>
    <script type="application/ld+json">
      {productSchema}
    </script>
    <script type="application/ld+json">
      {carSchema}
    </script>
    <script type="application/ld+json">
      {webPageSchema}
    </script>
  </Helmet>

SchemasHelmet.propTypes = {
  carSchema: PropTypes.string,
  productSchema: PropTypes.string,
  vehicleSchema: PropTypes.string,
  webPageSchema: PropTypes.string
}

export default SchemasHelmet
